import axios from 'axios';

let self = {};


self.getCertificateById = async(id) => {
    try {
        // search id as payload hash
        let data = (await axios.post('api/certs/getCertificate', {
            onlyOne: true,
            query: {'signature.payloadHash': id}
        })).data;

        if(!data.ok) {
            if(data.error !== 'NotInCollection') throw new Error(data.data || 'An unknown error occurred.');

            // search id as mongodb id
            data = (await axios.post('api/certs/getCertificate', {
                onlyOne: true,
                query: {'_id': id}
            })).data;
            if(!data.ok) throw new Error(data.data || 'An unknown error occurred.');
        }
        return data.data;
    } catch (error) {
        if(/Cast to ObjectId failed/gi.test(error.message)) throw new Error('Certificate ID Not Found.');
        throw error;
    }
};


export default self;
